/**
 * 工具
 */
export default {
	install(Vue) {

		/**
		 * 控制台日志
		 * 用于在视图中直接输出控制台日志
		 */
		Vue.prototype.$log = function () {
			console.log.apply(this, arguments);
		}

		/**
		 * 对象类型
		 * @param {*} target 目标
		 * @return {string} 返回对象类型
		 */
		Vue.prototype.$type = Vue.ext.type = function (target) {
			return target != null && (/^function (.*)\(/).exec(target.constructor.toString())[1];
		}

		/**
		 * 展开对象
		 * @param {*} target 目标
		 * @param {*} parent 父级
		 * @return {*} 返回展开的对象
		 */
		Vue.prototype.$unfold = Vue.ext.unfold = function (target, parent) {
			if (['Object', 'Array'].includes(Vue.ext.type(target))) {
				return Object.entries(target).reduce((p, [k, v]) => {
					let template = target instanceof Array ? '[$1]' : '.$1',
						key = parent ? `${parent}${k.replace(/^(.*)$/gm, template)}` : k,
						value = Vue.ext.unfold(v, key);
					if (Vue.ext.type(value) == 'Object') {
						Object.assign(p, value);
					} else {
						p[key] = value;
					}
					return p;
				}, {});
			} else {
				return target;
			}
		}

		/**
		 * URL解析
		 * @param {string} url 目标
		 * @return {Object} 返回解析后的对象
		 */
		Vue.prototype.$url = Vue.ext.url = Object.assign(function (url) {
			let [
				href = '',
				origin = '',
				protocol = '',
				host = '',
				hostname = '',
				port = '',
				pathname = '',
				search = '',
				hash = ''
			] = (/^(([^\/]*)\/\/(([^:\/]*):?([^\/]*)))?([^\?#]*)(\?[^#]*)?(.*)/gm).exec(url);
			return {
				href,
				origin,
				protocol,
				host,
				hostname,
				port,
				pathname,
				search,
				hash
			}
		}, {
				/**
				 * 路径合成
				 * @param {string} first 首个参数
				 * @param {string} surplus 剩余参数
				 * @return {string} 返回合成后的路径
				 */
				path(first, ...surplus) {
					return surplus.reduce((p, o) => {
						return String(p).replace(/^(.*[^\/])\/+$/, '$1')
							+ String(o).replace(/^\/*(.+)$/, '/$1');
					}, first);
				},
				/**
				 * 转换对象到Query字符串
				 * @param {Object} target 目标对象
				 * @return {string} 返回Query字符串
				 */
				toQuery(target = {}) {
					return Object.entries(Vue.ext.unfold(target)).reduce((p, [k, v]) => {
						return p.push(`${k}=${encodeURIComponent(v)}`), p;
					}, []).join('&')
				},
				/**
				 * 解析Query字符串到对象
				 * @param {string} query Query字符串
				 * @return {Object} 返回解析后的对象
				 */
				toObject(query = '') {
					return String(query).replace(/^\?/gm, '').split('&')
						.filter(s => s)
						.map(s => s.split('='))
						.reduce((p, [k, v]) => {
							if (k in p) {
								if (p[k] instanceof Array) {
									p.push(v)
								} else {
									p = [p[k], v]
								}
							} else {
								p[k] = v;
							}
							return p;
						}, {});
				},
				/**
				 * 转换对象到FormData数据
				 * @param {Object} target 目标对象
				 * @return {FormData} 返回FormData数据
				 */
				toFormData(target = {}) {
					return Object.entries(target).reduce((p, [k, v]) => {
						return p.append(k, v), p;
					}, new FormData());
				}
			});

		/**
		 * 延时器
		 * @param {Function} cb 回调
		 * @param {number} duration 时长
		 * @param {string} key 唯一标识
		 * @return {number} 返回延时器ID
		 */
		Vue.prototype.$timeout = Vue.ext.timeout = Object.assign(function (cb, duration = 0, key = 'default') {
			if (typeof duration == 'string') key = duration, duration = 0;
			key == 'default' || clearTimeout(Vue.ext.timeout.cache[key]);
			return Vue.ext.timeout.cache[key] = setTimeout(() => {
				cb instanceof Function && cb();
				delete Vue.ext.timeout.cache[key];
			}, duration);
		}, { cache: {} });

	}
}


// WEBPACK FOOTER //
// ./src/vue-ext/script/utils.js